jQuery(function ($) {
  var allAccordions = $(".accordion div.data");
  var allAccordionItems = $(
    ".accordion .wp-block-fseblocks-accordion-item .accordion-item"
  );
  $(".accordion > .wp-block-fseblocks-accordion-item .accordion-item").click(
    function () {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(this).next().slideUp("fast");
      } else {
        // Close all open accordion items
        allAccordionItems.removeClass("open");
        allAccordions.slideUp("fast");

        // Open the clicked accordion item
        $(this).addClass("open");
        $(this).next().slideDown("fast");
      }
      return false; // Prevent default link behavior
    }
  );
});

// orignal

// jQuery(function ($) {
//   var allAccordions = $(".accordion div.data");
//   var allAccordionItems = $(
//     ".accordion .wp-block-fseblocks-accordion-item .accordion-item"
//   );
//   $(".accordion > .wp-block-fseblocks-accordion-item .accordion-item").click(
//     function () {
//       if ($(this).hasClass("open")) {
//         $(this).removeClass("open");
//         $(this).next().slideUp("fast");
//       } else {
//         $(this).addClass("open");
//         $(this).next().slideDown("fast");
//         return false;
//       }
//     }
//   );
// });
